/* eslint-disable no-duplicate-imports */
/* eslint-disable no-duplicate-imports */
<!-- =========================================================================================
  File Name: FormWizardValidation.vue
  Description: Form wizard with validation
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <div class="vx-row form">
      <div
        class="vx-col w-full lg:w-2/3"
        v-scrollanimation
        v-appear:left="{ delay: 100 * 4 }"
      >
        <b-card class="card-round">
          <b-card class="rounded-card">
            <b-row class="stepIcons">
              <b-col v-for="step in stepCategories" :key="step.id">
                <b-row>
                  <b-col>
                    <div style="font-size: 2.5rem">
                      <b-icon
                        :icon="step.icon"
                        :class="
                          getCurrentStepStatus(step) == 'active'
                            ? 'p-2 rounded-circle bg-primary'
                            : getCurrentStepStatus(step) == 'done'
                            ? 'p-2 rounded-circle bg-secondary'
                            : 'p-2 rounded-circle bg-light'
                        "
                        :variant="
                          getCurrentStepStatus(step) == 'active'
                            ? 'secondary'
                            : getCurrentStepStatus(step) == 'done'
                            ? 'primary'
                            : getCurrentStepStatus(step) == 'done' &&
                              this.step == step.id
                            ? 'primary'
                            : 'secondary'
                        "
                      ></b-icon>
                    </div>
                  </b-col>
                  <b-col>
                    <div
                      v-if="getCurrentStepStatus(step) == 'active'"
                      class="d-lg-flex d-none"
                    >
                      <p class="pt-5">{{ step.title }}</p>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
          <br />
          <div v-if="!process">

                <!-- Section Map  -->
          <div class="step1 mx-5" v-if="step === 0">
            <b-row>
              <h4>Veuillez choisir l'emplacement de la maison</h4>
            </b-row>

            <br />
            <!-- <b-row>
            <b-col sm="6">
              <b-button block variant="outline-primary" size="lg" @click="getPosition()"
                >Choisir la position actuelle
              </b-button>
            </b-col>
            <b-col sm="6">
              <b-button block text-variant="primary" variant="outline-primary" size="lg"
                >Choisir sur le map
              </b-button>
            </b-col>
          </b-row> -->
            <b-row id="myAwesomeMap">
              <b-col>
                <div class="map">
                  <MglMap
                    :accessToken="accessToken"
                    :mapStyle="mapStyle"
                    :center="coordinates"
                    logoPosition="top-left"
                    container="myAwesomeMap"
                  >
                    <MglMarker
                      :coordinates.sync="coordinates"
                      color="blue"
                      :draggable="true"
                    />
                    <MglGeolocateControl
                      position="top-right"
                      :trackUserLocation="trackUser"
                      :showUserLocation="false"
                    />
                  </MglMap>
                </div>
              </b-col>
            </b-row>

            <b-row class="m-5">
              <multi-step-button
                :isFirstStep="true"
                :nextStep=" nextStep"
                :previousStep="previousStep"
                :step="step"
              />
            </b-row>
          </div>

      <!-- Section Description -->
          <div class="step1 mx-5" v-if="step === 1">
            <b-row>
              <b-col>
                <b-form-group label="Nom de l'announce">
                  <b-form-input
                    v-model="$v.rentalAnnouncement.rentInformation.name.$model"
                    required
                    :class="{
                      'is-invalid':
                        $v.rentalAnnouncement.rentInformation.name.$error,
                    }"
                    :formatter="toUpperFirstLetter"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    v-if="!$v.rentalAnnouncement.rentInformation.name.required"
                    >Votre nom est requis</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Type de propriété">
                  <b-form-select
                    v-model="$v.rentalAnnouncement.property.propertyType.$model"
                    :options="propertiesTypes"
                    :class="{
                      'is-invalid':
                        $v.rentalAnnouncement.property.propertyType.$error,
                    }"
                  ></b-form-select>
                  <b-form-invalid-feedback
                    v-if="$v.rentalAnnouncement.property.propertyType.$invalid"
                    >Le type de propriété est requis</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Type de location">
                  <b-form-select
                    v-model="$v.rentalAnnouncement.rentInformation.rentalType.$model"
                    :options="rentalTypes"
                    :class="{
                      'is-invalid':
                        $v.rentalAnnouncement.rentInformation.rentalType.$error,
                    }"
                  ></b-form-select>
                  <b-form-invalid-feedback
                    v-if="$v.rentalAnnouncement.rentInformation.rentalType.$invalid"
                    >Le type de location est requis</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Description">
                  <b-form-textarea
                    id="textarea-large"
                    size="lg"
                    placeholder="Decrivez votre logement"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <multi-step-button
              :nextStep="nextStep"
              :previousStep="previousStep"
              :step="step"
            />
          </div>

              <!-- Section Caracterisques -->

          <div class="step1 mx-5" v-if="step === 2">
            <h3>Veuillez indiquer le nombre qui sera à diposition des visteurs</h3>
            <br>
            <ol>
              <li> <b-row>
              <b-col class="align-center" cols="5"> <p>
<strong> &#128719;</strong> Lit</p></b-col>
              <b-col>
                <b-form-spinbutton
                  id="sb-inline"
                  v-model="$v.rentalAnnouncement.rentInformation.bed.$model"
                  min="1"
                  max="10"
                  inline
                ></b-form-spinbutton>
              </b-col>
              <b-col></b-col>
            </b-row> </li>
            <li>
               <b-row>
              <b-col class="align-center" cols="5"> <p>
&#128703; Salle de bains</p></b-col>
              <b-col>
                <b-form-spinbutton
                  id="sb-inline"
                  v-model="
                    $v.rentalAnnouncement.rentInformation.bathroom.$model
                  "
                  min="1"
                  max="10"
                  inline
                >
                </b-form-spinbutton
              ></b-col>
              <b-col></b-col>
            </b-row>
            </li>
            <li>
                 <b-row>
              <b-col class="align-center" cols="5"> <p>
&#128682; Chambre</p></b-col>
              <b-col>
                <b-form-spinbutton
                  id="sb-inline"
                  v-model="$v.rentalAnnouncement.rentInformation.bedroom.$model"
                  min="1"
                  max="10"
                  inline
                ></b-form-spinbutton>
              </b-col>
              <b-col></b-col>
            </b-row>
            </li>
            </ol>
    
            <br>
            
              <h5>Choisir les equipements disponibles</h5>
              
              <b-row>
              <b-form-group
                v-slot="{ ariaDescribedby }"
              >
                <b-form-checkbox-group
                  v-model="
                    $v.rentalAnnouncement.rentInformation.equipments.$model
                  "
                  :options="equipments"
                  :aria-describedby="ariaDescribedby"
                  name="flavour-1a"
                ></b-form-checkbox-group>
              </b-form-group>
            </b-row>
            <multi-step-button
              :nextStep="nextStep"
              :previousStep="previousStep"
              :step="step"
            />
          </div>

          <!-- Section Disponibilité -->
          <div class="step1" v-if="step === 3">
            <h3>Combien de temps à l'avance souhaiter vous être avertit de l'arrivée d'un visteur</h3>
            <div>
                <b-form-group v-slot="{ ariaDescribedby }">
      <b-form-radio-group
        id="radio-group-1"
        v-model="delay"
        :options="delayOptions"
        :aria-describedby="ariaDescribedby"
        name="radio-options"
        stacked
      ></b-form-radio-group>
    </b-form-group>

            </div>
            <multi-step-button
              :nextStep="nextStep"
              :previousStep="previousStep"
              :step="step"
            />
          </div>

          <!-- Section Critères -->
          <div class="step1" v-if="step === 4">
            <h3>Combien de visteurs autorisés vous ?</h3>
            <b-row>
              <b-col class="align-center" cols="5"> <p>
<strong>
&#128101;</strong> Adultes </p></b-col>
              <b-col>
                <b-form-spinbutton
                  id="sb-inline"
                  v-model="$v.rentalAnnouncement.rentInformation.visitors.$model"
                  min="1"
                  max="10"
                  inline
                ></b-form-spinbutton>
              </b-col>
              <b-col></b-col>
            </b-row>
            <multi-step-button
              :nextStep="nextStep"
              :previousStep="previousStep"
              :step="step"
            />
          </div>

          <!-- Section Price -->
          <div class="step1" v-if="step === 5">
            <h3>Quel tarif souhaitez-vous appliqué à cette offre ?</h3>

            <b-row>
              <b-col>      <b-form-group label="Prix">
                  <b-form-input
                    v-model="$v.rentalAnnouncement.rentInformation.pricePerNight.$model"
                    required
                    :class="{
                      'is-invalid':
                        $v.rentalAnnouncement.rentInformation.pricePerNight.$error,
                    }"
                    type="number"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    v-if="!$v.rentalAnnouncement.rentInformation.pricePerNight.required"
                    >Votre prix est requis</b-form-invalid-feedback
                  >
                </b-form-group></b-col>
                <b-col>
                  <p>FCFA / NUIT</p>
                </b-col>
            </b-row>
            <multi-step-button
              :nextStep="saveRentalAnnouncement"
              :previousStep="previousStep"
              :isLastStep="true"
              :step="step"
            />
          </div>
          </div>
          <div v-else>
                <b-row>
                  <b-col></b-col>
                  <b-col>
                       <b-spinner variant="primary" label="Spinning"></b-spinner>
                  </b-col>
                   <b-col></b-col>
              </b-row>

          </div>
          
        </b-card>
        <!-- 
      <b-card class="card-round">
        
          <div class="lines">
            <div class="dot"></div>
            <div class="line"></div>
            <div class="dot active"></div>
            <div class="line"></div>
            <div class="dot"></div>
            <div class="line"></div>
          </div>
      </b-card> -->
      </div>
      <div class="vx-col lg:w-1/3">
        <vx-card class="d-lg-flex d-none unique"> </vx-card>
      </div>
    </div>

    <b-row>
      <div class="svg-section d-lg-flex d-none">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          data-name="Layer 1"
          width="500"
          height="500"
          viewBox="0 0 840.5 757.83115"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <polygon
            points="534.25 438.618 418.25 300.618 185.404 302.746 44.156 440.325 47.01 442.159 45.991 442.159 45.991 728.324 533.937 728.324 533.937 442.159 534.25 438.618"
            fill="#3f3d56"
          />
          <polygon
            points="418.371 300.912 273.455 470.811 273.455 728.324 533.937 728.324 533.937 438.491 418.371 300.912"
            fill="#f9a826"
          />
          <rect
            x="378.01459"
            y="585.91537"
            width="53.19723"
            height="47.02019"
            fill="#fff"
          />
          <rect
            x="378.01459"
            y="504.52856"
            width="53.19723"
            height="46.27453"
            fill="#fff"
          />
          <rect
            x="141.60242"
            y="573.43886"
            width="53.19723"
            height="47.02019"
            fill="#fff"
          />
          <rect
            x="141.60242"
            y="492.05205"
            width="53.19723"
            height="46.27453"
            fill="#fff"
          />
          <rect y="727.43053" width="840.5" height="2" fill="#3f3d56" />
          <polygon
            points="713.92 695.831 717.92 715.831 697.92 719.831 700.92 694.831 713.92 695.831"
            fill="#a0616a"
          />
          <polygon
            points="776.92 691.831 771.92 716.831 747.92 716.831 757.92 686.831 776.92 691.831"
            fill="#a0616a"
          />
          <path
            d="M978.66929,588.91557l4,27-5,59-4,22-17,72s-19,0-22-8l5-41s4-33,3-37-16-68-16-68-22,101-25,110-7,48-7,48-17,3-18,0-2-74-2-85,2-17,2-19-7.8786-97.47192-7.8786-97.47192Z"
            transform="translate(-179.75 -71.08443)"
            fill="#2f2e41"
          />
          <path
            d="M937.66929,782.91557s5,1,8,0,0-7,0-7h11s12,27,17,29,21,24,2,24a62.08559,62.08559,0,0,1-33-10s-2-9-11-10-15-12-15-12l13-24S932.66929,783.91557,937.66929,782.91557Z"
            transform="translate(-179.75 -71.08443)"
            fill="#2f2e41"
          />
          <path
            d="M890.66929,781.91557s-2,4-4,2-4-7-4-7-6-3-7,0-5,19-7,21-23,23-2,27,25-5,25-5-3-5,3-7,7-9,7-9l-4-30S893.66929,783.91557,890.66929,781.91557Z"
            transform="translate(-179.75 -71.08443)"
            fill="#2f2e41"
          />
          <path
            d="M1001.66929,518.91557l3,52s14,33-5,32-7-33-7-33l-18.60235-46.40942Z"
            transform="translate(-179.75 -71.08443)"
            fill="#a0616a"
          />
          <path
            d="M847.66929,503.91557l-3,52s-14,33,5,32,7-33,7-33l18.60236-46.40942Z"
            transform="translate(-179.75 -71.08443)"
            fill="#a0616a"
          />
          <circle cx="747.91927" cy="293.83115" r="26" fill="#a0616a" />
          <path
            d="M948.16929,375.41557s-7,28,7,35-44,17-48,0l2-8s8-10,6-19Z"
            transform="translate(-179.75 -71.08443)"
            fill="#a0616a"
          />
          <path
            d="M932.66929,410.91557s-17.25519,1.61145-22.62756-9.69427c0,0-40.37244,2.69427-49.37244,39.69427l15,96s-16,28-14,31c0,0-10,28,82,29l40-2a55.64622,55.64622,0,0,0-1-17c-2-9-13-72-13-72s30-47,27-54-7.80438-34.60076-46.40222-45.80038C950.26707,406.11519,949.66929,411.91557,932.66929,410.91557Z"
            transform="translate(-179.75 -71.08443)"
            fill="#e6e6e6"
          />
          <path
            d="M983.66929,434.91557l13,17s13,71,9,72-28,9-32,6-22-62-22-62Z"
            transform="translate(-179.75 -71.08443)"
            fill="#e6e6e6"
          />
          <path
            d="M877.66929,429.91557l-17,11s-25,70-18,73,46,1,46,1Z"
            transform="translate(-179.75 -71.08443)"
            fill="#e6e6e6"
          />
          <path
            d="M956.089,341.64757s-9.00568-19.51227-26.26654-15.00943-27.017,11.25708-27.76746,18.01132.37525,16.88562.37525,16.88562,1.87616-13.88373,13.88373-10.88183c6.38656,1.59664,14.68386,1.70714,21.05261,1.46071a9.19307,9.19307,0,0,1,9.57007,9.30845l-.31464,21.49316S971.62205,366.91557,956.089,341.64757Z"
            transform="translate(-179.75 -71.08443)"
            fill="#2f2e41"
          />
          <path
            d="M833.45954,349.21456H480.27425a6.54816,6.54816,0,0,1-6.54045-6.54046V180.50271a6.54815,6.54815,0,0,1,6.54045-6.54045H833.45954A6.54815,6.54815,0,0,1,840,180.50271V342.6741A6.54816,6.54816,0,0,1,833.45954,349.21456ZM480.27425,176.57844a3.92856,3.92856,0,0,0-3.92427,3.92427V342.6741a3.92856,3.92856,0,0,0,3.92427,3.92427H833.45954a3.92857,3.92857,0,0,0,3.92428-3.92427V180.50271a3.92857,3.92857,0,0,0-3.92428-3.92427Z"
            transform="translate(-179.75 -71.08443)"
            fill="#e6e6e6"
          />
          <circle cx="352.78588" cy="160.32649" r="26.64236" fill="#f9a826" />
          <path
            d="M594.06705,213.64934a4.4404,4.4404,0,1,0,0,8.88079H803.39989a4.44039,4.44039,0,0,0,0-8.88079Z"
            transform="translate(-179.75 -71.08443)"
            fill="#e6e6e6"
          />
          <path
            d="M594.06705,240.2917a4.4404,4.4404,0,1,0,0,8.88079H684.1436a4.4404,4.4404,0,1,0,0-8.88079Z"
            transform="translate(-179.75 -71.08443)"
            fill="#e6e6e6"
          />
          <path
            d="M512.10048,282.88511c-3.37772,0-6.12638,1.99223-6.12638,4.4404s2.74866,4.44039,6.12638,4.44039H800.9154c3.37771,0,6.12638-1.99223,6.12638-4.44039s-2.74867-4.4404-6.12638-4.4404Z"
            transform="translate(-179.75 -71.08443)"
            fill="#e6e6e6"
          />
          <path
            d="M512.10048,309.52747c-3.37772,0-6.12638,1.99223-6.12638,4.4404s2.74866,4.44039,6.12638,4.44039H800.9154c3.37771,0,6.12638-1.99223,6.12638-4.44039s-2.74867-4.4404-6.12638-4.4404Z"
            transform="translate(-179.75 -71.08443)"
            fill="#e6e6e6"
          />
          <circle cx="590.09957" cy="47.38212" r="47.38212" fill="#f9a826" />
          <polygon
            points="590.1 124.408 575.284 98.747 560.469 73.086 590.1 73.086 619.73 73.086 604.915 98.747 590.1 124.408"
            fill="#f9a826"
          />
          <circle cx="590.48169" cy="47.08636" r="17" fill="#fff" />
          <ellipse cx="768.87205" cy="293.83115" rx="4" ry="5" fill="#a0616a" />
        </svg>
      </div>
    </b-row>
  </div>
</template>

<script>
import { FormWizard, TabContent, WizardButton } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import 'mapbox-gl/dist/mapbox-gl.css'

import Datepicker from 'vuejs-datepicker'
import UploadMultiple from '@/components/vuesax/upload/UploadMultiple'

import draggable from 'vuedraggable'
import MultiStepButton from '../../../../layouts/components/button/multi-step-button.vue'

import IncrementButton from '../../../../layouts/components/button/increment-button.vue'
// register custom messages

import Mapbox from 'mapbox-gl'
import { MglMap, MglGeolocateControl, MglMarker } from 'vue-mapbox'

import { validationMixin } from 'vuelidate'

const { required, numeric, minValue } = require('vuelidate/lib/validators')

import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    FormWizard,
    TabContent,
    Datepicker,
    UploadMultiple,
    draggable,
    WizardButton,
    MultiStepButton,
    IncrementButton,
    MglMap,
    MglGeolocateControl,
    MglMarker
  },
  mixins: [validationMixin],
  filters: {
    date (value) {
      if (!value) return ''
      const options = {year: 'numeric', month: 'long', day: 'numeric'}
      return Intl.DateTimeFormat('en-US', options).format(value)
    }
  },
  data () {
    return {
      accessToken:
        'pk.eyJ1Ijoib3JwaGVyaWMiLCJhIjoiY2t1bzlkNDcxMGNlbjJvbWRnbWIyOHN1YiJ9.qXEx5yXYTJ8w6nDz6QkGEw', // your access token. Needed if you using Mapbox maps
      mapStyle: 'mapbox://styles/mapbox/streets-v11',
      step: 0,
      trackUser: true,
      coordinates: [0, 0],
      stepCategories: [
        {
          id: 0,
          title: 'Emplacement',
          icon: 'geo-alt',
          status: 'active'
        },
        {
          id: 1,
          title: 'Description',
          icon: 'card-text',
          status: 'inactive'
        },
        {
          id: 2,
          title: 'Caracterisques',
          icon: 'card-checklist',
          status: 'inactive'
        },
        {
          id: 3,
          title: 'Disponibilite',
          icon: 'calendar2-week',
          status: 'inactive'
        },
        {
          id: 4,
          title: 'Critéres',
          icon: 'list-ol',
          status: 'inactive'
        },
        {
          id: 5,
          title: 'Prix',
          icon: 'sort-numeric-up-alt',
          status: 'inactive'
        }
      ],
      rentalAnnouncement: {
        rentInformation: {
          name: null,
          bedroom: 1,
          bathroom: 1,
          checkin: null,
          checkout: null,
          visitors: 1,
          description: null,
          bed: 1,
          equipments: [],
          pricePerNight: 0,
          rentalType: null
        },
        property: {
          position: {
            type: 'Point',
            coordinates: []
          },
          propertyType: null
        }
      },
      propertiesTypes: [
        {
          value: null,
          text: 'Choisir le type'
        }
      ],
      rentalTypes: [
        {
          value: null,
          text: 'Choisir le type'
        }
      ],
      equipments: [],
      delayOptions:[
        { text: 'Le jour meme', value: 'first' },
        { text: 'une semaine', value: 'second' }

      ],
      delay:null
    }
  },
  validations: {
    rentalAnnouncement: {
      rentInformation: {
        name: {
          required
        },
        bedroom: {
          required
        },
        bathroom: {
          numeric,
          required
        },
        checkin: {
          required
        },
        checkout: {
          required
        },
        visitors: {
          required
        },
        description: {},
        bed: {
          required
        },
        equipments: {

        },
        pricePerNight: {
          required,
          minValue : minValue(1)
        },
        rentalType: {
          required
        }
      },
      property: {
        position: {
          coordinates: {
            required
          }
        },
        propertyType: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters({process: 'addRentalAnnouncementProcess',
      error: 'addRentalAnnouncementError',
      success: 'addRentalAnnouncementSuccess'}),
    isLastStep () {
      return this.step === this.stepCategories.length - 1
    },
    isFirstStep () {
      return this.step === 0
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler () {
        this.getPosition()
        this.getPropertyType()
        this.getEquipement()
        this.getRentalTypes()
      }
    },
    success () {
      this.$vs.notify({
        title: 'Enregistrement Réussie',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success',
        position:'top-right'
      })
      this.$router.push('/')
    
    },
    error (val) {
      if (val) {
        this.$vs.notify({
          title: 'Enregistrement echoué',
          text: val,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          position:'top-right'
        })
      }
    }
  },
  methods: {
    ...mapActions(['addRentalAnnouncement']),
    toUpperFirstLetter (value) {
      const str1 = value.charAt(0).toUpperCase()
      const str2 = value.slice(1, value.length).toLowerCase()
      return str1 + str2
    },
    nextStep (step) {
      let valid = null
      switch (step) {
      case 0:
        this.rentalAnnouncement.property.position.coordinates = this.coordinates
        this.$v.rentalAnnouncement.property.position.coordinates.$touch()
        valid = this.$v.rentalAnnouncement.property.position.coordinates.$invalid
        break
      case 1:
        this.$v.rentalAnnouncement.rentInformation.name.$touch()
        this.$v.rentalAnnouncement.rentInformation.rentalType.$touch()
        this.$v.rentalAnnouncement.property.propertyType.$touch()
        valid = this.$v.rentalAnnouncement.rentInformation.name.$invalid || this.$v.rentalAnnouncement.rentInformation.rentalType.$invalid ||  this.$v.rentalAnnouncement.property.propertyType.$invalid
      
        break
      case 5:
        this.$v.rentalAnnouncement.rentInformation.pricePerNight.$touch()
        valid =  this.$v.rentalAnnouncement.rentInformation.pricePerNight.$invalid 

      }
      if (!valid) {
        this.step += 1
        this.stepCategories[step].status = 'done'
        this.stepCategories[step + 1].status = 'active'
      }
      
      return null
    },
    previousStep () {
      this.stepCategories[this.step].status = 'unactive'
      this.stepCategories[this.step - 1].status = 'active'
      this.step -= 1
    },
    getCurrentStepStatus (step) {
      return step.status
    },
    getPosition () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.coordinates = [
            position.coords.longitude,
            position.coords.latitude
          ]
          // console.log(this.rentalAnnouncement.property.position.coordinates)
        })
      } else {
        console.log('Geolocation is not supported by this browser.')
      }
    },
    async getPropertyType () {
      await this.$http.get('/property/property-type').then((result) => {
        result.data.forEach((element) => {
          this.propertiesTypes.push({
            value: element._id,
            text: element.name
          })
        })
      })
    },
    async getRentalTypes () {
      await this.$http.get('/rental-type').then((result) => {
        result.data.forEach((element) => {
          this.rentalTypes.push({
            value: element._id,
            text: element.name
          })
        })
      })
    },
    async getEquipement () {
      await this.$http.get('/equipment/get-all-equipments').then((result) => {
        result.data.forEach((element) => {
          this.equipments.push({
            value: element._id,
            text: element.name
          })
        })
      })
    },
    saveRentalAnnouncement () {
      this.rentalAnnouncement.rentInformation.checkin = new Date()
      this.rentalAnnouncement.rentInformation.checkout = new Date().setFullYear(new Date().getFullYear() + 1)
      this.$v.rentalAnnouncement.$touch()
      if (!this.$v.rentalAnnouncement.$invalid) {
        this.addRentalAnnouncement(this.rentalAnnouncement)
      }
    }
  },
  created () {
    // We need to set mapbox-gl library here in order to use it in template
    this.mapbox = Mapbox
  }
}
</script>
<style lang="scss" >
.unique {
  min-height: 34rem;
  background-image: url("../../../../assets/images/pages/owner/leon.jpg");
  background-position: center;
  background-size: cover;
}
.svg-section {
  min-height: 34rem;
  @media screen and (max-width: 767px) {
    min-height: 3rem;
  }
  width: 100%;
}
.card-round {
  border-radius: 20px;
  min-height: 395px;
  border: 0px solid rgba(0, 0, 0, 0.125);
}
.rounded-card {
  border-radius: 10px;
  // height: 60px;
}
.stepIcons {
  margin-top: -10px;
}
.lines {
  margin-left: 40px;
  margin-top: 6px;

  .dot {
    width: 14px;
    height: 14px;
    background: #d1d6e6;
    border-radius: 7px;
  }
  .active {
    background: yellow;
  }
  .line {
    height: 103px;
    width: 2px;
    background: #d1d6e6;
    margin-left: 5.3px;
  }
}

#myAwesomeMap {
  height: 500px;
  width: 100%;
}
ol{
  list-style-type:round($number: 1)
}
</style>